<p><strong>Vodafone Analytics</strong> &copy; {{ year }}</p>
